import { Clock } from 'lucide-react';

interface TimelineConnectorProps {
  duration: string;
}

export function TimelineConnector({ duration }: TimelineConnectorProps) {
  return (
    <div className="relative flex items-center py-2 ml-[15px]">
      {/* Dashed vertical line */}
      <div className="absolute left-0 top-0 bottom-0 w-px border-l border-dashed border-slate-300" />

      {/* Duration pill */}
      <div className="ml-5 inline-flex items-center gap-1.5 text-[11px] text-slate-400 bg-slate-50 px-2.5 py-1 rounded-full border border-slate-200/60">
        <Clock className="h-3 w-3" />
        <span className="font-medium">{duration}</span>
      </div>
    </div>
  );
}
